import { useQuery } from 'react-query';
import { cartService, iteroProposalService } from 'services';
import { useIteroProposalNotificationStore } from 'store';
import { ServerStateKeysEnum } from '../../constants';
import { useDoctorProfile } from '../useDoctorProfile';

export const useRetriveIteroProposal = () => {
  const { data: doctorProfile } = useDoctorProfile();
  const setShowNotification = useIteroProposalNotificationStore(
    state => state.setShowNotification
  );
  return useQuery(
    `${ServerStateKeysEnum.approvedIteroProposalDetails}`,
    () => {
      return iteroProposalService.getApprovedIteroProposals();
    },
    {
      staleTime: Infinity,
      onSuccess: data => {
        setShowNotification(data.showNotification);
      },
    }
  );
};
